export default __webpack_public_path__ + "static/layout_cloud_middleRight-1c6906adce61d4b9b7ae7d5e11c10e9f.webp";